import S3 from "react-aws-s3";
import api from "./api";

window.Buffer = window.Buffer || require("buffer").Buffer;

export const isMobile = () =>
  typeof window !== "undefined" ? window.innerWidth <= 600 : false;
export const isTab = () =>
  typeof window !== "undefined" ? window.innerWidth <= 1024 : false;

let timeout = null;

export const debounce = (callback, time = 500) => {
  if (timeout) {
    clearTimeout(timeout);
  }
  timeout = setTimeout(() => {
    callback();
  }, time);
};

export const table = [
  { id: "1", title: "Name" },
  { id: "2", title: "Starting from ₹" },
  { id: "3", title: "Typology" },
  { id: "4", title: "Possession Date" },
  { id: "5", title: "No of Units" },
  { id: "6", title: "Land Area (in Acres)" },
  { id: "7", title: "No of Units in Phase" },
  { id: "8", title: "Width of Access Road (in meters)" },
  { id: "9", title: "Project Density (Units Per Acre)" },
  { id: "10", title: "Price psft on RERA Carpet Area" },
  { id: "11", title: "Efficiency of Floor Plan" },
  { id: "12", title: "Units Per Elevator" },
  { id: "13", title: "Floor to Ceiling Height (in meters)" },
  { id: "14", title: "Project Development Model" },
  { id: "15", title: "Open Areas (%)" },
  { id: "16", title: "Clubhouse Size (sqft)" },
  { id: "17", title: "Clubhouse Area Per Unit (sqft)" },
];

/**
 * @param {string} userName
 * @returns {string}
 */
export const getInitials = (userName, lastName) =>
  (lastName ? `${userName} ${lastName}` : userName)
    ?.split(" ")
    ?.slice(0, 2)
    ?.map((splitName) => splitName[0])
    ?.join("")
    ?.toUpperCase();

/**
 * verify file extension , file
 * @param {File} file
 * @returns true if format verified
 */
export const verifyUploadFileImageExtension = (file, ext) => {
  if (file) {
    const fileExtension = file.name.split(".").pop();
    const allowedExtensions = [
      "jpg",
      "jpeg",
      "svg",
      "png",
      "PNG",
      "JPG",
      "JPEG",
      "SVG",
      ...(ext || []),
    ];

    const allowedSize = 50 * 1000000; // 50mb
    return (
      allowedExtensions.includes(fileExtension) && file?.size <= allowedSize
    );
  }
  return false;
};
/**
 * verify file extension , file
 * @param {File} file
 * @returns true if format verified
 */
export const verifyUploadFileExcelExtension = (file) => {
  if (file) {
    const fileExtension = file.name.split(".").pop();
    const allowedExtensions = ["xlsx"];

    const allowedSize = 50 * 1000000; // 50mb
    return (
      allowedExtensions.includes(fileExtension) && file?.size <= allowedSize
    );
  }
  return false;
};

/**
 * Upload file to S3 bucket
 * @param {File} file
 * @returns returns object with "location" key (url) of the uploaded file to S3
 */
export const uploadFile = (file) => {
  const formData = new FormData();

  formData.append("file", file);

  const config = {
    bucketName: process.env.REACT_APP_S3_BUCKET_CONTENT,
    region: process.env.REACT_APP_S3_REGION_CONTENT,
    accessKeyId: process.env.REACT_APP_AWS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  };

  const ReactS3Client = new S3(config);

  const newFileName = file.name || "test-file";

  return ReactS3Client.uploadFile(file, newFileName);
};

/**
 * Upload file to Cloudinary
 * @param {File} file
 * @returns returns object with "location" key (url) of the uploaded file to S3
 */
export const uploadFileCloudinary = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", process.env.REACT_APP_CLOUDINARY_PRESET);
  const url = `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_NAME}/auto/upload`;
  const res = await fetch(url, {
    method: "POST",
    body: formData,
  });

  const data = await res.json();

  return data;
};

export const optionFetch = async (
  path,
  labelAttribute,
  valueAttribute,
  searchString,
  applyCustomFilter
) => {
  return new Promise((resolve) => {
    Promise.resolve(
      api(path, {
        method: "get",
      })
    ).then((value) => {
      let defaultValueSet = value?.data?.data
        ?.map((item) => {
          return {
            label: item?.[labelAttribute],
            value: item?.[valueAttribute],
            data: item,
          };
        })
        ?.filter((val) =>
          val?.label
            ?.toLowerCase()
            ?.includes((searchString || "")?.toLowerCase())
        );

      if (applyCustomFilter) {
        defaultValueSet = applyCustomFilter(defaultValueSet);
      }

      resolve(defaultValueSet);
    });
  });
};

export const alphaNumericIndexing = (index) => {
  const A_code = 65;
  let resultIndexing = "";

  if (index <= 25) {
    resultIndexing += String.fromCharCode(A_code + index);
  }

  if (index > 25 && index < 676) {
    resultIndexing += String.fromCharCode(A_code + (parseInt(index / 26) - 1));
    resultIndexing += String.fromCharCode(A_code + parseInt(index % 26));
  }

  return resultIndexing;
};

export const formatCurrency = (value, currency) => {
  const formatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: parseFloat(currency) || "INR",
    minimumFractionDigits: 2,
  });

  return formatter.format(Number(value || 0));
};
